import { useMemo } from 'react'
import { useSuspenseQuery } from '@apollo/client'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'

export default function useOrganizations() {
  const { data } = useSuspenseQuery(AdminAPI.organization.GET_ALL)

  return useMemo(
    () =>
      data.getOrganizations.map(org =>
        getFragment(SharedAPI.organization.ORGANIZATION_FRAGMENT, org)
      ),
    [data]
  )
}
